import React, { useState, useEffect } from 'react'
import ReactOnRails from 'react-on-rails'
import axios from 'axios'
import { FormattedMessage } from 'react-intl'
import { Redirect } from 'react-router-dom'
import FeedbackSnackbar from 'shared/components/FeedbackSnackbar/FeedbackSnackbar'
import TechlinkJobShow from './TechlinkJobShow/TechlinkJobShow'
import TechlinkCompanyShow from './TechlinkCompanyShow/TechlinkCompanyShow'
import URLHandler from 'assets/URLHandler.js'
import CircularProgress from '@material-ui/core/CircularProgress'
import LostJobPage from 'pages/Lost/LostJobPage/LostJobPage'

const TechlinkItemShowFactory = (props) => {
    const [state, setState] = useState({
        item: {},
        itemid: props.match.params.itemid.split('?')[0],
        needRedirect: false,
        redirect_to: '',
        loading: true,
        unavailable: false,
        doesNotExist: false
    })
    const [feedback, setFeedback] = useState({
        open: false,
        severity: 'success',
        message: null
    })

    useEffect(() => {
        const delay = 500
        const timerId = setTimeout(() => {
            if (!state.loading) window.prerenderReady = true
        }, delay)

        return () => clearTimeout(timerId)
    }, [state])

    useEffect(() => {
        axios.defaults.headers.common['X-CSRF-TOKEN'] = ReactOnRails.authenticityToken()
        axios.get(
            props.getAllInfoUrl + props.match.params.itemid,
            { params: { locale: URLHandler.GetLocaleFromUrl() } }
        )
            .then((response) => {
                setState({
                    ...state,
                    item: response.data,
                    loading: false,
                    jobs: response.data.all_jobs,
                    jobsCount: response.data.total_jobs_count,
                    unavailable: response.data.unavailable,
                    doesNotExist: response.data.does_not_exist
                })
            })
            .catch((error) => {
                if (error.response) {
                    setState({
                        ...state,
                        item: error.response.data,
                        loading: false,
                        unavailable: error.response.data.unavailable,
                        doesNotExist: error.response.data.does_not_exist
                    })
                } else {
                    setFeedback({
                        open: true,
                        severity: 'error',
                        message: <FormattedMessage id='item_show.error.server_crash' />
                    })
                }
            })
    }, [])

    const closeFeedback = () => {
        setFeedback({ ...feedback, open: false })
    }

    const renderItemShow = () => {
        if (props.renderType === 'job') {
            return (
                <TechlinkJobShow
                    {...props}
                    job={state.item}
                    user={props.user}
                    recentArticles={props.recentArticles}
                    ads={props.ads}
                    unavailable={state.unavailable}
                    doesNotExist={state.doesNotExist}
                />
            )
        }
        if (props.renderType === 'company') {
            return (
                <TechlinkCompanyShow
                    {...props}
                    company={state.item}
                    user={props.user}
                    jobs={state.jobs}
                    jobsCount={state.jobsCount}
                    unavailable={state.unavailable}
                    doesNotExist={state.doesNotExist}
                />
            )
        }
    }

    const shouldRenderDoesNotExist = () => {
        return (
            state.doesNotExist
        )
    }

    const renderShowContent = () => {
        if (shouldRenderDoesNotExist()) {
            return renderDoesNotExist()
        } else {
            return renderItemShow()
        }
    }

    const renderDoesNotExist = () => {
        return <LostJobPage user={props.user} />
    }

    if (state.needRedirect) {
        return <Redirect to={state.redirect_to}/>
    }

    return (
        <div>
            <FeedbackSnackbar
                open={feedback.open}
                message={feedback.message}
                severity={feedback.severity}
                closeFeedback={closeFeedback}
            />
            {state.loading
                ? <div className="loading-cirular">
                    <CircularProgress color='primary' style={{ width: '80px', height: '80px' }}/>
                </div>
                : renderShowContent()
            }
        </div>
    )
}

export default TechlinkItemShowFactory
